import { j as c, c as m } from "./utils-BdNIfrGQ.js";
import { c as f } from "./index-Di82Y7n3.js";
import { n as x } from "./normalize-spacing-DY0KSpr_.js";
import { n as p } from "./normalize-gap-CHOQjV8I.js";
const d = f("list-inside flex", {
  variants: {
    direction: {
      horizontal: "flex-row flex-wrap",
      vertical: "flex-col",
      responsive: "flex-col md:flex-row"
    },
    align: {
      left: "text-left",
      center: "text-center",
      right: "text-right"
    },
    style: {
      none: "list-none",
      disc: "list-disc",
      decimal: "list-decimal"
    }
  },
  defaultVariants: {
    direction: "vertical",
    style: "none",
    align: "left"
  }
}), j = ({
  as: t = "ul",
  direction: e,
  align: i,
  style: n,
  children: l,
  spacing: r,
  gap: s,
  ...o
}) => {
  const a = t;
  return /* @__PURE__ */ c.jsx(
    a,
    {
      className: m(
        d({ direction: e, align: i, style: n }),
        x(r),
        p(s)
      ),
      ...o,
      children: l
    }
  );
};
export {
  j as L
};
